import { useEffect, useState } from 'react';
import firebase from 'firebase';
import 'firebase/firestore';
import {Link} from 'react-router-dom'


const Tomusiccont = (props) => {
    
    return (
        <div className='to-person flex-col'>
            <Link  to='/Music'><img className='to-music-img' src={props.dp} onClick={
                e=>localStorage.setItem('music-phone',props.phone)
            } /></Link>
            <span>{props.name}</span>
        </div>
    )
}

const Tomusic = () => {
	const [people, setPeople] = useState([]);
	const firestore = firebase.firestore();
	const myPhone = localStorage.getItem('user-phone');

	useEffect((e) => {
		function getPeople() {
			const ref = firestore.collection(`users`);
			const array = [];
			
			ref.get().then((docs) => {
				docs.forEach((snap) => {
					const data = snap.data();

					const det = {
						name: data.name,
						phone: data.phone,
						dp: data.dp,
						caption: data.caption,
					};
					
					 array.push(det);
					setPeople([...people, ...array]);
				});
			});
		}

		getPeople();
	}, []);
	return (
		<div className="to-music-bar flex-start">
			{people.map((a) => {
				return <Tomusiccont key={a.phone} name={a.name} phone={a.phone} dp={a.dp} caption={a.caption} />;
			})}
		</div>
	);
};

export default Tomusic;
